import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import type { AuditLog } from '@repo/api-gw-sdk';
import type { Row } from '@tanstack/react-table';
import { useState } from 'react';
import { JsonDialog } from '@/components/shared/jsonDialog';
export const AuditLogOperationCell = t0 => {
  const $ = _c(11);
  const {
    row
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== row.original.operationName) {
    t2 = <Typography variant="subtitle1" className="underline hover:cursor-pointer hover:text-(--mui-palette-text-secondary)" onClick={t1}>{row.original.operationName}</Typography>;
    $[1] = row.original.operationName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `Audit log parameters - ${row.original.operationName}`;
  let t5;
  if ($[4] !== isOpen || $[5] !== row.original || $[6] !== t4) {
    t5 = <JsonDialog isOpen={isOpen} onClose={t3} title={t4} data={row.original} closeTestId="close-audit-log-json-viewer" />;
    $[4] = isOpen;
    $[5] = row.original;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};